import styled from "styled-components";

const SiderDiv = styled.div`
  display: flex;
  color: #757575;
  height: 50px;
  min-height: 50px;
  font-size: 14px;
  line-height: 16px;
  padding: 0 20px;
  align-items: center;
`;
export default SiderDiv;
